export enum ENpsVoteType {
  ONBOARDING = 'ONBOARDING',
  REGULAR = 'REGULAR'
}

export enum EVoteReason {
  VIDEO_CONTENT = 'VIDEO_CONTENT',
  STUDY_MATERIAL = 'STUDY_MATERIAL',
  TEACHER_MONITORING = 'TEACHER_MONITORING',
  INCOMPLETE_SYLLABUS = 'INCOMPLETE_SYLLABUS',
  LIVE_CLASSES = 'LIVE_CLASSES',
  QUIZZES_FOR_PRACTICE = 'QUIZZES_FOR_PRACTICE',
  QUIZZES_QUANTITY = 'QUIZZES_QUANTITY',
  QUIZZES_QUALITY = 'QUIZZES_QUALITY',
  PLATFORM_FUNCTIONING = 'PLATFORM_FUNCTIONING',
  EXAM_DATES = 'EXAM_DATES',
  BETTER_CONTENT = 'BETTER_CONTENT',
  MORE_LIVE_CLASSES = 'MORE_LIVE_CLASSES',
  STUDENT_ATTENDANCE = 'STUDENT_ATTENDANCE',
  PREVIOUS_EXAMS = 'PREVIOUS_EXAMS',
  TEACHERS = 'TEACHERS',
  HELP_TO_USE_PLATFORM = 'HELP_TO_USE_PLATFORM',
  MORE_CLARITY_HOW_TO_STUDY = 'MORE_CLARITY_HOW_TO_STUDY',
  METHODS_ORIENTATION = 'METHODS_ORIENTATION',
  BETTER_GENERAL_CONTENT = 'BETTER_GENERAL_CONTENT',
  MORE_QUIZZES_FOR_PRACTICE = 'MORE_QUIZZES_FOR_PRACTICE',
  DONT_KNOW_START = 'DONT_KNOW_START',
  DONT_KNOW_USE_THE_APP = 'DONT_KNOW_USE_THE_APP',
  DONT_KNOW_ORGANIZE_STUDY = 'DONT_KNOW_ORGANIZE_STUDY',
  DONT_KNOW_PRACTICE_MODE = 'DONT_KNOW_PRACTICE_MODE',
  DONT_KNOW_TALK_TO_TUTOR = 'DONT_KNOW_TALK_TO_TUTOR',
  DONT_KNOW_SEE_RECORDED_CLASSES = 'DONT_KNOW_SEE_RECORDED_CLASSES',
  DONT_KNOW_FOLLOW_EXAMS = 'DONT_KNOW_FOLLOW_EXAMS',
  OTHER = 'OTHER'
}

export const DETRACTOR_REASONS = [
  EVoteReason.VIDEO_CONTENT,
  EVoteReason.STUDY_MATERIAL,
  EVoteReason.TEACHER_MONITORING,
  EVoteReason.INCOMPLETE_SYLLABUS,
  EVoteReason.LIVE_CLASSES,
  EVoteReason.PLATFORM_FUNCTIONING,
  EVoteReason.EXAM_DATES,
  EVoteReason.STUDENT_ATTENDANCE,
  EVoteReason.OTHER
] as const;

export const NEUTRAL_REASONS = [
  EVoteReason.BETTER_CONTENT,
  EVoteReason.MORE_LIVE_CLASSES,
  EVoteReason.QUIZZES_QUANTITY,
  EVoteReason.STUDENT_ATTENDANCE,
  EVoteReason.STUDY_MATERIAL,
  EVoteReason.TEACHER_MONITORING,
  EVoteReason.QUIZZES_QUALITY,
  EVoteReason.OTHER
] as const;

export const PROMOTER_REASONS = [
  EVoteReason.LIVE_CLASSES,
  EVoteReason.VIDEO_CONTENT,
  EVoteReason.STUDY_MATERIAL,
  EVoteReason.TEACHERS,
  EVoteReason.QUIZZES_FOR_PRACTICE,
  EVoteReason.PREVIOUS_EXAMS,
  EVoteReason.STUDENT_ATTENDANCE,
  EVoteReason.OTHER
] as const;

export const ONBOARDING_DETRACTOR_REASONS = [
  EVoteReason.TEACHER_MONITORING,
  EVoteReason.STUDENT_ATTENDANCE,
  EVoteReason.HELP_TO_USE_PLATFORM,
  EVoteReason.MORE_CLARITY_HOW_TO_STUDY,
  EVoteReason.METHODS_ORIENTATION,
  EVoteReason.BETTER_GENERAL_CONTENT,
  EVoteReason.MORE_QUIZZES_FOR_PRACTICE,
  EVoteReason.OTHER
] as const;

export const NO_CLEAR_REASONS = [
  EVoteReason.DONT_KNOW_START,
  EVoteReason.DONT_KNOW_USE_THE_APP,
  EVoteReason.DONT_KNOW_ORGANIZE_STUDY,
  EVoteReason.DONT_KNOW_PRACTICE_MODE,
  EVoteReason.DONT_KNOW_TALK_TO_TUTOR,
  EVoteReason.DONT_KNOW_SEE_RECORDED_CLASSES,
  EVoteReason.DONT_KNOW_FOLLOW_EXAMS,
  EVoteReason.OTHER
] as const;
